// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "javascripts/" + chunkId + "." + "79cbd96" + ".min.js";
};